'use client';

import { useEffect, useRef } from 'react';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/src/components/ui/card';
import { Button } from '@/src/components/ui/button';
import { logger } from '@/src/logging/logger';

export default function Error({
  error,
  reset,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  reset: () => void;
  unstable_retry: () => void;
}) {
  const headingRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    logger.error('Unhandled application error', error, { digest: error.digest });
    headingRef.current?.focus();
  }, [error]);

  return (
    <main className="grid min-h-screen place-items-center bg-background p-6">
      <section aria-labelledby="application-error-title" className="w-full max-w-md">
        <Card role="alert" aria-labelledby="application-error-title" className="border-destructive/30 bg-destructive/5">
          <CardHeader>
            <CardTitle>
              <h1 id="application-error-title" ref={headingRef} tabIndex={-1}>
                We couldn’t load this page
              </h1>
            </CardTitle>
            <CardDescription>
              SparkOne hit an unexpected problem. Try loading the page again, or reset this view if the problem continues.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="flex flex-wrap gap-2">
              <Button type="button" onClick={unstable_retry}>
                Try again
              </Button>
              <Button type="button" variant="outline" onClick={reset}>
                Reset view
              </Button>
            </div>
          </CardContent>
        </Card>
      </section>
    </main>
  );
}
